import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import { AuthProvider } from "./auth/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import CookieBanner from "./components/CookieBanner";

import HomePage from "./pages/HomePage";
import VeteranServicesPage from "./pages/VeteranServicesPage";
import InsurancePage from "./pages/InsurancePage";
import EducationPage from "./pages/EducationPage";
import ResourcesPage from "./pages/ResourcesPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import SchedulePage from "./pages/SchedulePage";
import AdminDashboard from "./pages/AdminDashboard";
import SubServicePage from "./pages/SubServicePage";
import ResourceDetailPage from "./pages/ResourceDetailPage";
import LoginPage from "./pages/LoginPage";
import { ForgotPasswordPage, ResetPasswordPage } from "./pages/PasswordResetPages";
import LegalPage from "./pages/LegalPage";
import InsuranceConsultationPage from "./pages/InsuranceConsultationPage";
import InsuranceThankYouPage from "./pages/InsuranceThankYouPage";

import { VETERAN_SUB_SERVICES } from "./lib/veteranSubServices";
import { INSURANCE_PRODUCTS } from "./lib/insuranceProducts";
import { EDUCATION_PROGRAMS } from "./lib/educationPrograms";

const SiteLayout = () => {
  const location = useLocation();
  // Admin dashboard AND insurance consultation form have their own layouts (no site nav/footer)
  const hideChrome =
    location.pathname.startsWith("/admin") ||
    location.pathname === "/insurance/consultation" ||
    location.pathname === "/insurance/thank-you";

  return (
    <>
      {!hideChrome && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/veteran-services" element={<VeteranServicesPage />} />
          <Route
            path="/veteran-services/:slug"
            element={<SubServicePage dataMap={VETERAN_SUB_SERVICES} division="veteran" />}
          />
          <Route path="/insurance" element={<InsurancePage />} />
          <Route path="/insurance/consultation" element={<InsuranceConsultationPage />} />
          <Route path="/insurance/thank-you" element={<InsuranceThankYouPage />} />
          <Route
            path="/insurance/:slug"
            element={<SubServicePage dataMap={INSURANCE_PRODUCTS} division="insurance" />}
          />
          <Route path="/education" element={<EducationPage />} />
          <Route
            path="/education/:slug"
            element={<SubServicePage dataMap={EDUCATION_PROGRAMS} division="education" />}
          />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/resources/:slug" element={<ResourceDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/schedule" element={<SchedulePage />} />

          {/* Staff auth pages (no public registration) */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* Legal pages */}
          <Route path="/privacy" element={<LegalPage />} />
          <Route path="/terms" element={<LegalPage />} />
          <Route path="/disclaimer" element={<LegalPage />} />
          <Route path="/cookies" element={<LegalPage />} />
          <Route path="/legal/:slug" element={<LegalPage />} />

          {/* Admin */}
          <Route path="/admin" element={<AdminDashboard />} />

          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      {!hideChrome && <Footer />}
      {!hideChrome && <CookieBanner />}
    </>
  );
};

function App() {
  // Preserve legacy /#admin backward compat
  if (typeof window !== "undefined" && window.location.hash === "#admin") {
    window.location.replace("/admin");
  }

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <SiteLayout />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
